import { HubConnectionBuilder } from '@microsoft/signalr';
import { Button } from 'devextreme-react/button';
import React from 'react';

import ServiceArtists from '../../../../api/services/ServiceArtists';

import HxToast from '../../../custom-components/hx-toast/HxToast'
import HxDialog from '../../../custom-components/hx-dialog/HxDialog'
import HxPopupExportExcel from '../../../custom-components/hx-popup-excel-export/HxPopupExportExcel';

import HxErrorMessage from '../../../custom-components/hx-error-message/HxErrorMessage';

import DataGridArtistsShuttles from './sub-components/DataGridArtistsShuttles';
import PopupArtistNameShuttles from './sub-components/PopupArtistNameShuttles';

import './ShuttlesAdminArtists.scss';


class ShuttlesAdminArtists extends React.Component {
    constructor(props) {
        super(props);

        // popup
        this.popupArtistNameInstance = null;

        this.popupExportArtistsInstance = null;

        this.dataGridArtistsInstance = null;

        this.hubConnection = null;

    }

    componentDidMount = async () => {
        this.hubConnection = new HubConnectionBuilder().withUrl("/artistsHub").build();

        await this.hubConnection.start()
            .then(function () {
            })
            .catch(function (err) {
                return console.error(err.toString());
            });
    }


    // GRID
    dataGridArtists_OnInitialized = (instance) => {
        this.dataGridArtistsInstance = instance;
    }

    dataGridArtists_OnExportArtist = () => {
        this.exportArtist();
    }

    dataGridArtists_OnConnectionError = () => {
        this.setErrorHeader(true);
    }

    dataGridArtists_OnEditArtist = (id, name, notes) => {
        this.refPopupArtistName.setValues(id, name, notes, 'update');
        this.popupArtistNameInstance.show();
    }

    dataGridArtists_OnDeleteArtist = async (id, name) => {
        var dataCanBeDeleted = await ServiceArtists.checkIfArtistCanBeDeleted(id);
        if (dataCanBeDeleted == true) {
            var result = await HxDialog.showDialogYesNo('Delete artist', 'Delete artist ' + name + '?')
            if (result === true) {
                var data = await ServiceArtists.deleteArtist(id);
                if (data !== null) {
                    if (!data.hasOwnProperty("error")) {
                        if (data) {
                            this.refDataGridArtists.gridRefresh();
                            this.hubConnection
                                .invoke("SendUpdateInfoDeletedArtistShuttles", id)
                                .catch(function (err) {
                                    return console.error(err.toString());
                                });
                            HxToast.showToast('Artist deleted.', 'success', 'bottom right', 'up-stack');
                        } else {
                            HxToast.showToast('Delete artist failed!', 'error', 'bottom right', 'up-stack');
                        }
                    } else {
                        this.setErrorHeader(true);
                    }
                } else {
                    HxToast.showToast('Delete artist failed!', 'error', 'bottom right', 'up-stack');
                }
            }
        } else {
            HxToast.showToast('Artist can not be deleted.', 'warning', 'bottom right', 'up-stack');
        }
    }

    // POPUP EXPORT
    popupExportArtists_OnInitialized = (instance) => {
        this.popupExportArtistsInstance = instance;
    }

    popupExportArtists_OnSave = async (fileName) => {
        if (fileName) {
            await this.refDataGridArtists.exportToExcel(fileName);
        }
    }

    exportArtist = () => {
        this.popupExportArtistsInstance.show();
    }

    popupArtistName_OnInitialized = (instance) => {
        this.popupArtistNameInstance = instance;
    }

    popupArtistName_OnUpdate = async (id, name, notes, editMode) => {
        switch (editMode.toLowerCase().trim()) {
            case 'save':
                var model = {
                    Id: -1,
                    EventId: parseInt(sessionStorage.getItem("currentEventId"), 10),
                    ColorId: null,
                    ArtistTypeId: null,
                    Name: name,
                    Notes: notes,
                    UseInRiders: false,
                    UseInShuttles: true,
                }
                await this.onAddArtistCallBack(model);
                break;
            case 'update':
                var model = {
                    Id: id,
                    EventId: parseInt(sessionStorage.getItem("currentEventId"), 10),
                    ColorId: null,
                    ArtistTypeId: null,
                    Name: name,
                    Notes: notes,
                    UseInRiders: false,
                    UseInShuttles: true,
                }
                await this.onUpdateArtistCallBack(model);
                break;
            default:
                break;
        }
    }

    onUpdateArtistCallBack = async (artistInfoModel) => {
        await this.updateArtist(artistInfoModel);
        this.refDataGridArtists.gridRefresh();
    }

    onAddArtistCallBack = async (artistInfoModel) => {
        var id = await this.addArtist(artistInfoModel);
        this.refDataGridArtists.gridRefresh();
    }

    updateArtist = async (artistInfoModel) => {
        let resultName = false;
        var data = await ServiceArtists.updateArtist(artistInfoModel);
        if (data !== null) {
            if (!data.hasOwnProperty("error")) {
                if (data === true) {
                    //this.refDataGridArtists.gridRefresh();
                    this.hubConnection
                        .invoke("SendUpdateInfoEditedArtistShuttles", artistInfoModel.Id)
                        .catch(function (err) {
                            return console.error(err.toString());
                        });
                    resultName = true;
                }
            } else {
                this.setErrorHeader(true);
            }
        }

        if (resultName) {
            HxToast.showToast('Artist updated.', 'success', 'bottom right', 'up-stack');
        } else {
            HxToast.showToast('Update artist failed!', 'error', 'bottom right', 'up-stack');
        }

    }

    addArtist = async (artistInfoModel) => {
        var data = await ServiceArtists.addArtist(artistInfoModel);
        if (data !== null) {
            if (!data.hasOwnProperty("error")) {
                if (data !== -1) {
                    this.refDataGridArtists.gridRefresh();
                    this.hubConnection
                        .invoke("SendUpdateInfoAddedArtistShuttles", artistInfoModel.Id)
                        .catch(function (err) {
                            return console.error(err.toString());
                        });
                    HxToast.showToast('Artist saved.', 'success', 'bottom right', 'up-stack');
                } else {
                    HxToast.showToast('Save artist failed!', 'error', 'bottom right', 'up-stack');
                }
            } else {
                this.setErrorHeader(true);
            }
        } else {
            HxToast.showToast('Save artist failed!', 'error', 'bottom right', 'up-stack');
        }

        return data;
    }

    buttonNew_OnClick = () => {
        this.refPopupArtistName.setValues(-1, '', null, 'save');
        this.popupArtistNameInstance.show();
    }

    // ERROR MESSAGE
    setErrorHeader = (show) => {
        if (show) {
            this.refHxErrorMessage.show();
        } else {
            this.refHxErrorMessage.hide();
        }
    }

    render() {
        return (
            <div>
                <HxErrorMessage
                    ref={ref => this.refHxErrorMessage = ref}
                    id='error-message-artists'
                    message='Could not connect to database!'
                    visible={false}
                />
                <div id='toolBarArtistsShuttles' className='hx-toolbar-main-div'>
                    <div className='hx-toolbar-left'>
                        <span>
                            <Button
                                icon='xlsxfile'
                                stylingMode='outlined'
                                text='Artists'
                                onClick={this.exportArtist}
                            />
                        </span>
                    </div>
                    <div className='hx-toolbar-right'>
                    </div>
                </div>

                <div className='artists-content-block'>
                    <div>
                        <Button
                            text="Add artist"
                            icon="add"
                            onClick={this.buttonNew_OnClick} />
                    </div>
                    <div className='artists-grid-card'>
                        <DataGridArtistsShuttles
                            ref={ref => this.refDataGridArtists = ref}
                            onEditArtist={this.dataGridArtists_OnEditArtist}
                            onDeleteArtist={this.dataGridArtists_OnDeleteArtist}
                            onInitialized={this.dataGridArtists_OnInitialized}
                            onExportArtist={this.dataGridArtists_OnExportArtist}
                            onConnectionError={this.dataGridArtists_OnConnectionError}
                        />
                    </div>
                </div>

                <HxPopupExportExcel
                    defaultName='Artists'
                    onInitialized={this.popupExportArtists_OnInitialized}
                    onSave={this.popupExportArtists_OnSave}
                />

                <PopupArtistNameShuttles
                    ref={ref => this.refPopupArtistName = ref}
                    title='Save artist ...'
                    onInitialized={this.popupArtistName_OnInitialized}
                    onUpdate={this.popupArtistName_OnUpdate}
                />
            </div>
        );
    }
}

export default ShuttlesAdminArtists

